import { Environments } from '@product/cabify-environments';

import { type ApplicationConfig } from './index';

export const config: ApplicationConfig = {
  appEnv: Environments.DEV,
  url: {
    apiBase: '/support/api',
  },
};
